const template=`
<div class="widgetDetails">
  <div class="widgetContentMax insWidgetMax worldMap">
    <widget-status></widget-status>
    <map-highchart data="mapSettings" drill="drill(id, type, parentCountry, parentContinent)" loading="widgetIsLoading" drillmap="drillmap(id, type, callback)" maximized="isMaximized" data-ng-hide="widgetIsLoading || serviceError || noDataFromServer || notConfigured"></map-highchart>
    <div class="clearfix" style="height:45px;"></div>
    <widget-content-stream-maximized widget="widget" is-loading="widgetIsLoading" update-content-stream-query="updateContentStreamQuery" ng-if="widget.hasRequiredSettings()"></widget-content-stream-maximized>
  </div>
</div>`;
export default template;
